// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

function resolveConfigFile(origin: string): string {
  if (origin === 'https://autohub.ie') {
    return './assets/environments/environment.local.json';
  }
  if (origin.includes('.vercel.app')) {
    return './assets/environments/environment-vercel.json';
  }
  // Coolify lab shop UI (see environment.lab.json)
  if (origin.includes('lab.thehubfactory.net')) {
    return './assets/environments/environment.lab.json';
  }
  return './assets/environments/environment.dev.json';
}

function isLocalBackend(backendUrl: string): boolean {
  return /localhost|127\.0\.0\.1/.test(backendUrl);
}

function applyBackendImageBase(config: Record<string, unknown>): Promise<Record<string, unknown>> {
  const backend = String(config['backendURL'] || '').replace(/\/+$/, '');
  if (!isLocalBackend(backend)) {
    return Promise.resolve(config);
  }

  return fetch(backend + '/api/config')
    .then(response => (response.ok ? response.json() : null))
    .then(apiConfig => {
      const imagesBaseUrl = apiConfig?.imagesBaseUrl;
      config['images'] = imagesBaseUrl || backend + '/static';
      return config;
    })
    .catch(() => {
      config['images'] = backend + '/static';
      return config;
    });
}

export const environment = new Promise((resolve, reject) => {
  const xhr = new XMLHttpRequest();
  const configFile = resolveConfigFile(window.location.origin);

  xhr.open('GET', configFile, true);
  xhr.onload = function () {
    if (xhr.status !== 200) {
      reject('Cannot load configuration');
      return;
    }
    const config = JSON.parse(xhr.responseText);
    applyBackendImageBase(config).then(resolve).catch(reject);
  };
  xhr.onerror = function () {
    reject('Cannot load configuration');
  };
  xhr.send();
});
